/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useEffect, useState} from 'react';
import * as PropTypes from "prop-types";
import Tooltip from "../Tooltip.jsx";
import {BaseIconList} from "./Icons.js";
import {ErrorHandler} from "../../ErrorHandling.js";


function getIconURL(iconName) {
    if (Object.keys(BaseIconList).includes(iconName)) {
        iconName = BaseIconList[iconName]
    }

    let iconFamily = "io";

    if (iconName.startsWith("Cg")) {
        iconFamily = "cg"

    } else if (iconName.startsWith("IoIos") || iconName.startsWith("IoMd")) {
        iconFamily = "io"

    } else if (iconName.startsWith("Io5") || iconName.startsWith("Io")) {
        iconFamily = "io5"
        iconName = iconName.replace("Outline", "").replace("Sharp", "") + "Outline"
    } else if (iconName.startsWith("Hi")) {
        iconFamily = "hi"

    } else if (iconName.startsWith("Bs")) {
        iconFamily = "bs"
    } else if (iconName.startsWith("Tb")) {
        iconFamily = "tb"
    } else if (iconName.startsWith("Ti")) {
        iconFamily = "ti"
    } else if (iconName.startsWith("Md")) {
        iconFamily = "md"
    } else if (iconName.startsWith("Bi")) {
        iconFamily = "bi"
    } else if (iconName.startsWith("Gr")) {
        iconFamily = "gr"
    } else if (iconName.startsWith("Ai")) {
        iconFamily = "ai"
    } else if (iconName.startsWith("Fi")) {
        iconFamily = "fi"
    } else if (iconName.startsWith("Gi")) {
        iconFamily = "gi"
    } else if (iconName.startsWith("Go")) {
        iconFamily = "go"
    } else if (iconName.startsWith("Rx")) {
        iconFamily = "rx"
    } else if (iconName.startsWith("Fa")) {
        iconFamily = "fa"
    } else if (iconName.startsWith("Si")) {
        iconFamily = "si"
    } else if (iconName.startsWith("Ri")) {
        iconFamily = "ri"
    } else if (iconName.startsWith("Im")) {
        iconFamily = "im"
    } else if (iconName.startsWith("Lia")) {
        iconFamily = "lia"
    } else if (iconName.startsWith("Lu")) {
        iconFamily = "lu"
        if (iconName === "LuTestTube2") {
            iconName = "LuTestTubeDiagonal"
        }
    } else if (iconName.startsWith("Ci")) {
        iconFamily = "ci"
    } else if (iconName.startsWith("Pi")) {
        iconFamily = "pi"
    } else if (iconName.startsWith("Fc")) {
        iconFamily = "fc"
    }

    let iconURL = `/icons/${iconFamily}/${iconName}.svg`
    return iconURL
}


function DisplayIcon({iconName = "", className = "", style = {}, onClick}) {
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        // if the icon Name changes the error has to be reset
        setHasError(false)
    }, [iconName]);

    if (hasError) {

        return (<Tooltip
            text={<div>The Icon '{iconName}' was not found !</div>}
        >
            <svg
                style={style}
                className={`${className} text-red-400!`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
            >
                <path
                    d="M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeMiterlimit={10}
                    strokeWidth={40}
                />
                <circle cx={248} cy="399.99" r={32} fill={"currentColor"}/>
            </svg>
        </Tooltip>)
    }


    let iconURL = getIconURL(iconName)

    return (<>
        <svg className={`h-4 w-4 ${className ?? ``} iconElement`}
             onClick={onClick}
             fill="currentColor"
             style={{
                 ...style,
                 background: "currentcolor",
                 mask: `url(${iconURL}) center center / contain no-repeat`,
             }}/>

        {/*We render the icon as image to check if it was found and if not emit an error */}
        <img src={iconURL} className={"hidden"}
             onError={(event) => {
                 ErrorHandler.recordError(`The icon ${iconName} was not found.`)
                 setHasError(true)
             }}/>

    </>)

}

DisplayIcon.propTypes = {
    /**
     * The name of the icon
     * @type {'DigitalTwin'|'DigitalTwinAttribute'|'Spinner'|'Edit'|'Add'|'Search'|string}
     */
    iconName: PropTypes.string,
    className: PropTypes.string,

}
export default DisplayIcon;
export {getIconURL}

